import { render, staticRenderFns } from "./pic.vue?vue&type=template&id=089d68a9&scoped=true&"
import script from "./pic.vue?vue&type=script&lang=js&"
export * from "./pic.vue?vue&type=script&lang=js&"
import style0 from "./pic.vue?vue&type=style&index=0&lang=css&"
import style1 from "./pic.vue?vue&type=style&index=1&id=089d68a9&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "089d68a9",
  null
  
)

export default component.exports